import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import LogoIcon from '../../svg/LogoIcon';
import Button from '../Button';

const Header = () => (
  <header className="sticky top-0 bg-white shadow">
    <div className="container flex flex-col sm:flex-row justify-between items-center mx-auto py-4 px-8">
      <div className="flex items-center text-2xl">
        {/* <div className="w-12 mr-3">
          <LogoIcon />
        </div> */}
        <a href="/" class="hover:underline underline-offset-4">
          SISBC
        </a>

      </div>
      <div className="flex mt-4 sm:mt-0">
        {/* <AnchorLink className="px-4" href="#features">
          Board Members
        </AnchorLink>
        <AnchorLink className="px-4" href="#services">
          Board of Trustees
        </AnchorLink> */}
        <a href="/funeral-services" class="hover:underline underline-offset-4 text-xl">
          Funeral Services
        </a>


        {/* <AnchorLink className="px-4" href="#stats">
          Stats
        </AnchorLink>
        <AnchorLink className="px-4" href="#testimonials">
          Testimonials
        </AnchorLink> */}
      </div>
      <div className="hidden md:block">
        <Button className="text-sm">Become a SISBC Member</Button>
      </div>
    </div>
  </header>
);

export default Header;
